import script from "./CourseIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseIndex.vue?vue&type=script&setup=true&lang=js"

import "./CourseIndex.vue?vue&type=style&index=0&id=7cda6617&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cda6617"]])

export default __exports__